import { Component, OnInit } from '@angular/core';
import { PageMixin } from 'src/app/services/mixins/page.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { InfoService } from 'src/app/services/info.service';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AdvertiseForm } from '@shared/forms/advertise.form';


import { MarketingService } from '@services/marketing.service';

import { BaseComponent } from '../../base.component';
import { ClientService } from '../../../services/client.service';
import { LangService } from '../../../services/lang.service';

@Component({
    selector: 'app-page-pricing',
    templateUrl: './pricing.component.html',

})
export class PricingComponent extends PageMixin(BaseComponent)
    implements OnInit {
    public userData: Record<string, any>;

    public constructor(
        protected page: PageService,
        protected translate: TranslateService,
        protected client: ClientService,
        public lang: LangService,
        public form: AdvertiseForm,
        public marketing: MarketingService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,

    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.lang.getLang().then((): Promise<any> => this.createTitle());
    }

    /**
     * Create page title and meta
     * @return Promise<any>
     */
    private createTitle(): any {
        this.translate.get('web.title_contact').subscribe((): void => {
            const trans = this.translate.instant('web.title_pricingt');
            const client = this.client.getVName();
            this.setTitle(
                {
                    title: `${trans} | ${client}`,
                    description: this.translate.instant('web.description_pricing'),
                },
                true,
            );
        });
    }
}
